<h2>General Appearance</h2>

<assessment-row title="LOC">
    <p>{{ data.loc }}</p>
</assessment-row>
<assessment-row title="Orientation">
    <emr-list [list]="data.orientation" emptyText="N/A"></emr-list>
</assessment-row>
<assessment-row title="Lethargic">
    <p>{{ isLethargic }}</p>
</assessment-row>
<assessment-row title="Inappropriate for Age">
    <p>{{ isInappropriateForAge }}</p>
</assessment-row>
<assessment-row title="In Distress">
    <p>{{ inDistress }}</p>
</assessment-row>

@if (patient().isObstetric()) {
<assessment-row title="Inappropriate Baby Bonding">
    <p>{{ data.babyBonding ? "Yes" : "No" }}</p>
</assessment-row>

<assessment-row title="Breast Abnormalities">
    <p>{{ data.hasBreastAbnormalities ? "Yes" : "No" }}</p>
</assessment-row>

@if (data.hasBreastAbnormalities) {
<assessment-row title="Nipple Abnormalities Notes">
    <p>{{ data.nippleAbnormalitiesNotes }}</p>
</assessment-row>

<assessment-row title="Breast Abnormalities Notes">
    <p>{{ data.breastAbnormalitiesNotes }}</p>
</assessment-row>
}
}